import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatMYR } from "../../lib/api";
import publicApi from "../../lib/publicApi";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { CheckCircle2, ShoppingBag, Home } from "lucide-react";

export default function ShopThankYou() {
    const location = useLocation();
    const { invoiceNo } = useParams();
    const nav = useNavigate();
    const order = location.state;

    return (
        <div className="max-w-2xl mx-auto py-8" data-testid="shop-thank-you">
            <Card className="p-8 border-gold-200 bg-white/80 backdrop-blur-sm shadow-lg text-center">
                <div className="h-16 w-16 rounded-full bg-gold-100 flex items-center justify-center mx-auto mb-4">
                    <CheckCircle2 className="h-8 w-8 text-gold-700" />
                </div>
                <h1 className="text-3xl font-bold text-slate-900">下单成功！</h1>
                <p className="text-sm text-slate-500 mt-2">
                    感谢您的选购。我们已收到订单，会尽快联系您确认付款方式。
                </p>

                <div className="mt-6 p-4 rounded-lg bg-gold-50 border border-gold-200 text-left">
                    <div className="text-xs uppercase tracking-widest text-gold-700">订单编号 / Invoice No.</div>
                    <div className="text-2xl font-bold font-mono text-slate-900 mt-1">{invoiceNo}</div>
                    {order && (
                        <div className="mt-4 space-y-1 text-sm">
                            <div className="flex justify-between"><span className="text-slate-500">应付总额</span><span className="font-mono font-bold text-gold-700">{formatMYR(order.total)}</span></div>
                            <div className="flex justify-between"><span className="text-slate-500">配送方式</span><span className="font-medium">{order.delivery_method}</span></div>
                            <div className="flex justify-between"><span className="text-slate-500">订单状态</span><span className="font-medium text-amber-700">待处理</span></div>
                            {order.vip_tier && (
                                <div className="flex justify-between"><span className="text-slate-500">VIP 待遇</span><span className="font-medium text-gold-700">已自动应用</span></div>
                            )}
                        </div>
                    )}
                </div>

                <div className="mt-6 flex flex-wrap gap-3 justify-center">
                    {order && order.id && order.payment_status !== "paid" && (
                        <Button
                            data-testid="pay-now-btn"
                            onClick={async () => {
                                try {
                                    const { data } = await publicApi.post("/public/payments/checkout", {
                                        order_id: order.id,
                                        origin_url: window.location.origin,
                                    });
                                    window.location.href = data.checkout_url;
                                } catch (err) {
                                    alert(err.response?.data?.detail || "创建付款失败");
                                }
                            }}
                            className="gap-2 bg-gold-600 hover:bg-gold-700 text-white shadow-lg"
                        >
                            💳 在线付款 (Stripe)
                        </Button>
                    )}
                    <Button onClick={() => nav("/shop")} variant="outline" className="gap-2 border-gold-300 text-gold-700"><ShoppingBag className="h-4 w-4" /> 继续购物</Button>
                    <Button onClick={() => nav("/")} className="gap-2 bg-gold-600 hover:bg-gold-700 text-white"><Home className="h-4 w-4" /> 返回首页</Button>
                </div>

                <div className="mt-6 pt-4 border-t border-gold-100 text-xs text-slate-500">
                    请截图或记录订单编号以便日后查询。
                </div>
            </Card>
        </div>
    );
}
